module.exports = __webpack_public_path__ + "fonts/8e50278c-45cd-4808-b774-24767d958f17.2409b7c4.ttf";